    <!-- components/admin/progressbar.vue -->
<template>
    <!-- 仪表盘内容 -->
    <div class="bar-container">
        <div class="progress-bar">

            <div class="step">
             <span :class="step1_no_class">1</span>
             <span class="step1_label_class">创建团队</span>

            </div>
            <div class="step">
                <span :class="step2_no_class">2</span>
             <span :class="step2_label_class">构建知识库</span>
            </div>
            <div class="step">
                <span :class="step3_no_class">3</span>
                <span :class="step3_label_class">上传文档</span>
            </div>
            <div class="step">
                <span :class="step4_no_class">4</span>
                <span :class="step4_label_class">测试机器人</span>
            </div>
            <div class="step">
                <span :class="step5_no_class"><svg v-if="aics_center_count>0 && aics_seat_count>0" t="1757903183775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5742" width="20" height="20"><path d="M836.821696 277.905766c3.166487-43.42207-6.931275-81.047382-30.34973-112.238122-64.548914-85.935399-211.262794-95.214728-271.347018-95.214728-10.893617 0-18.366751 0.31044-21.143777 0.451549a443.234748 443.234748 0 0 0-21.143777-0.451549c-60.089869 0-206.803748 9.27933-271.341374 95.209084-21.589681 28.746731-31.839841 62.968493-30.846433 102.157292-20.494675 23.514409-90.050138 111.752706-61.986375 197.185757 21.990431 66.930835 97.286209 112.610649 223.770698 135.865417 39.713725 39.792746 75.01356 61.57998 92.804586 71.13024v154.768382H347.320119a31.574556 31.574556 0 0 0-2.274677-0.073376c-4.769485 0-46.565979 1.800551-46.56598 64.255407 0 59.576232 37.794642 62.595965 45.375019 62.595965 1.5014 0 2.805247-0.09031 3.877676-0.197553h332.503671c1.066784 0.112887 2.376276 0.197553 3.877677 0.197553 7.580377 0 45.375019-3.019733 45.375019-62.595965 0-62.449212-41.802139-64.255407-46.56598-64.255407-0.897453 0-1.665087 0.028222-2.274677 0.073376H582.723845v-154.768382c16.808908-9.019689 49.224474-28.916062 86.240194-64.63358 128.059266-23.10237 204.235564-68.95716 226.367104-136.339544 26.663962-81.14898-34.718465-164.781479-58.509447-193.121816zM166.226436 452.773718c-15.313152-46.42487 10.329181-97.658737 32.313967-130.209767 0.897453 3.561592 1.834417 7.134472 2.889913 10.758152C228.935288 428.102216 268.507904 498.684952 308.35145 550.47761c-79.241186-21.584037-128.002822-54.891412-142.125014-97.703892z m691.57535 5.920935c-14.13348 43.015676-63.228134 76.441583-143.050689 98.036909 41.469121-52.323228 83.158373-124.768603 111.786572-223.409459 0.225774-0.784566 0.40075-1.546555 0.62088-2.325476 21.584037 32.545386 45.561283 82.272208 30.643237 127.698026z" fill="#5B5B5D" p-id="5743"></path><path d="M555.185007 641.594532l-11.97169 5.12508v219.55436h138.292493l0.355594 0.361239 1.450601-0.344306c2.438364 0.824077 6.665991 7.360247 6.665991 24.648925 0 15.578437-3.49386 21.759012-5.3057 22.887885h-338.21012l-0.445904-0.891809-2.579473 0.97083c-1.766685-0.903098-5.441164-6.999008-5.441165-22.961261 0-17.452365 4.312292-23.94338 6.688568-24.671503h140.064822v-206.527175l-0.056443-12.970741-11.864447-5.164591c-1.614287-0.705545-161.993165-73.054966-233.450778-319.307155-15.922743-54.880123-11.3113-99.600397 13.715798-132.913416 55.35425-73.698424 197.496197-79.42745 239.749884-79.42745 12.37244 0 19.890729 0.44026 19.964106 0.44026l1.19096 0.067732 1.168383-0.067732c0.073377 0 7.586021-0.44026 19.964105-0.44026 42.248043 0 184.401279 5.729027 239.755529 79.42745 25.027097 33.318664 29.63854 78.033293 13.715797 132.913416-71.463257 246.252188-231.853423 318.607254-233.416911 319.290222z" fill="#FAD603" p-id="5744"></path><path d="M513.986815 229.736788l36.219866 73.399272 81.002227 11.774137-58.611047 57.132224 13.834329 80.674854-72.445375-38.088149-72.462308 38.088149 13.839973-80.674854-58.61669-57.132224 81.007871-11.774137z" fill="#F96A03" p-id="5745"></path></svg>
                    <svg v-else t="1757903183775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5742" width="20" height="20"><path d="M836.821696 277.905766c3.166487-43.42207-6.931275-81.047382-30.34973-112.238122-64.548914-85.935399-211.262794-95.214728-271.347018-95.214728-10.893617 0-18.366751 0.31044-21.143777 0.451549a443.234748 443.234748 0 0 0-21.143777-0.451549c-60.089869 0-206.803748 9.27933-271.341374 95.209084-21.589681 28.746731-31.839841 62.968493-30.846433 102.157292-20.494675 23.514409-90.050138 111.752706-61.986375 197.185757 21.990431 66.930835 97.286209 112.610649 223.770698 135.865417 39.713725 39.792746 75.01356 61.57998 92.804586 71.13024v154.768382H347.320119a31.574556 31.574556 0 0 0-2.274677-0.073376c-4.769485 0-46.565979 1.800551-46.56598 64.255407 0 59.576232 37.794642 62.595965 45.375019 62.595965 1.5014 0 2.805247-0.09031 3.877676-0.197553h332.503671c1.066784 0.112887 2.376276 0.197553 3.877677 0.197553 7.580377 0 45.375019-3.019733 45.375019-62.595965 0-62.449212-41.802139-64.255407-46.56598-64.255407-0.897453 0-1.665087 0.028222-2.274677 0.073376H582.723845v-154.768382c16.808908-9.019689 49.224474-28.916062 86.240194-64.63358 128.059266-23.10237 204.235564-68.95716 226.367104-136.339544 26.663962-81.14898-34.718465-164.781479-58.509447-193.121816zM166.226436 452.773718c-15.313152-46.42487 10.329181-97.658737 32.313967-130.209767 0.897453 3.561592 1.834417 7.134472 2.889913 10.758152C228.935288 428.102216 268.507904 498.684952 308.35145 550.47761c-79.241186-21.584037-128.002822-54.891412-142.125014-97.703892z m691.57535 5.920935c-14.13348 43.015676-63.228134 76.441583-143.050689 98.036909 41.469121-52.323228 83.158373-124.768603 111.786572-223.409459 0.225774-0.784566 0.40075-1.546555 0.62088-2.325476 21.584037 32.545386 45.561283 82.272208 30.643237 127.698026z" fill="#cdcdcd" p-id="5743"></path><path d="M555.185007 641.594532l-11.97169 5.12508v219.55436h138.292493l0.355594 0.361239 1.450601-0.344306c2.438364 0.824077 6.665991 7.360247 6.665991 24.648925 0 15.578437-3.49386 21.759012-5.3057 22.887885h-338.21012l-0.445904-0.891809-2.579473 0.97083c-1.766685-0.903098-5.441164-6.999008-5.441165-22.961261 0-17.452365 4.312292-23.94338 6.688568-24.671503h140.064822v-206.527175l-0.056443-12.970741-11.864447-5.164591c-1.614287-0.705545-161.993165-73.054966-233.450778-319.307155-15.922743-54.880123-11.3113-99.600397 13.715798-132.913416 55.35425-73.698424 197.496197-79.42745 239.749884-79.42745 12.37244 0 19.890729 0.44026 19.964106 0.44026l1.19096 0.067732 1.168383-0.067732c0.073377 0 7.586021-0.44026 19.964105-0.44026 42.248043 0 184.401279 5.729027 239.755529 79.42745 25.027097 33.318664 29.63854 78.033293 13.715797 132.913416-71.463257 246.252188-231.853423 318.607254-233.416911 319.290222z" fill="#cdcdcd" p-id="5744"></path><path d="M513.986815 229.736788l36.219866 73.399272 81.002227 11.774137-58.611047 57.132224 13.834329 80.674854-72.445375-38.088149-72.462308 38.088149 13.839973-80.674854-58.61669-57.132224 81.007871-11.774137z" fill="#cdcdcd" p-id="5745"></path></svg>
                </span>

                <span :class="step5_label_class">部署AI客服中心</span>
            </div>
        </div>
    </div>
</template>

<script>
import { countDashboard } from '@/api/tenant/dashboard';
export default {
   name: "AdminProgressbar",
   props: {
    tenantId:{
        type: Number,
        value:0
        },
        //当前页面属于第几步，0-仪表盘，1-员工管理，2-知识库管理，3-机器人管理，4-AI客服中心管理
        currentStep:{
        type: Number,
        value:0
        },
   },
   data() {
        return {
           step1_no_class:"step-no",
           step2_no_class:"step-no",
           step3_no_class:"step-no",
           step4_no_class:"step-no",
           step5_no_class:"step-no",
           step1_label_class:"step-label",
           step2_label_class:"step-label",
           step3_label_class:"step-label",
           step4_label_class:"step-label",
           step5_label_class:"step-label",
           employee_count: 0,
            workspace_count:0,
            document_count:0,
            aics_center_count:0,
            aics_seat_count:0
        }
    },
   mounted() {
    console.log("mounted tenantId:"+ this.tenantId+
        ",currentStep:"+ this.currentStep)
        // 获取所有统计数据
        countDashboard(this.tenantId).then(res => {
          let realdata = res.data.data;
          console.log("realdata:",realdata)
        if(res.data.code === 200){
          this.employee_count = realdata.employees_count;
          this.workspace_count = realdata.knowledge_count;
          this.document_count = realdata.document_count;
          this.aics_center_count = realdata.aics_center_count;
          this.aics_seat_count = realdata.aics_seat_count;
          this.solved_rate = realdata.ai_resoved_rate;
          this.missed_hits_rate = realdata.missed_hits_rate;
          console.log("employee_count:"+ this.employee_count);
          console.log("workspace_count:"+ this.workspace_count);
          console.log("document_count:"+ this.document_count);
          console.log("aics_center_count:"+ this.aics_center_count);
          //流程图的步骤1状态
          if(this.currentStep == 1){
            if(this.employee_count > 0){
                this.step1_no_class = "step-no-active-finished";
            }else{
                this.step1_no_class = "step-no-active";
            }
           }
           else{
            if(this.employee_count > 0){
                this.step1_no_class = "step-no-finished";
            }else{
                this.step1_no_class = "step-no";
            }
           }
            this.step1_label_class = this.currentStep == 1? "step-label-active" : "step-label";
            console.log("step1_no_class:"+ this.step1_no_class);
            //流程图的步骤2状态
            if(this.currentStep == 2){
                if(this.workspace_count > 0){
                    this.step2_no_class = "step-no-active-finished";
                }else{
                    this.step2_no_class = "step-no-active";
                }
            }
            else{
                if(this.workspace_count > 0){
                    this.step2_no_class = "step-no-finished";
                }else{
                    this.step2_no_class = "step-no";
                }
            }
            this.step2_label_class = this.currentStep == 2? "step-label-active" : "step-label";
            console.log("step2_no_class:"+ this.step2_no_class);
            //流程图的步骤3状态
            if(this.currentStep == 3){
                if(this.document_count > 0){
                    this.step3_no_class = "step-no-active-finished";
                }else{
                    this.step3_no_class = "step-no-active";
                }
            }
            this.step3_label_class = this.currentStep == 3? "step-label-active" : "step-label";
            console.log("step3_no_class:"+ this.step3_no_class);
            //流程图的步骤4状态
            if(this.currentStep == 4){
                if(this.aics_center_count > 0){
                    this.step4_no_class = "step-no-active-finished";
                }else{
                    this.step4_no_class = "step-no-active";
                }
            }
            this.step4_label_class = this.currentStep == 4? "step-label-active" : "step-label";
            console.log("step4_no_class:"+ this.step4_no_class);

            //流程图的步骤4状态
            if(this.currentStep == 5){
                if(this.aics_center_count > 0){
                    this.step5_no_class = "step-no-active-finished";
                }else{
                    this.step5_no_class = "step-no-active";
                }
            }
            this.step5_label_class = this.currentStep == 5? "step-label-active" : "step-label";
            console.log("step5_no_class:"+ this.step5_no_class);
          }// 200

        });


   }
}



 </script>
 <style>

/* 仪表盘样式 */
.bar-containter {
    margin: -20px;
    display: block;
width: 100%;
margin: 0;
padding: 0;
height: 70px;
background-color: white;
}
.progress-bar{
  position: relative;
  width: 100%;
  height: 50px;
  display: flex;
  padding: 15px 0 15px 0;
  background-image: linear-gradient(to right,
        transparent 10%,
        #ddd 10%,
        #ddd 90%,
        transparent 90%);
    background-size: 100% 3px;
    background-position: center 50%;
    background-repeat: no-repeat;
  margin: 0;
}
.step{
    margin: 0;
    display: inline-block;
    background: transparent;

    height: 60px;
    color: #333;
    padding: 5px 0 5px 0;
    width: 20%;
    text-align: center;

}
.step-no-active-finished{
    display: block;
    padding-top: 5px;
    width: 30px;
    height: 25px;
    border-radius: 50%;
    margin-top: 10px;
    color: white;
    font-size: 1.0rem;
    font-weight: bold;
    background-color: #057FDB;
    border: 2px solid #057FDB;
    margin-bottom: 10px;
    margin: auto;


}

.step-no-active{
    padding-top: 5px;
    display: block;
    width: 30px;
    height: 25px;
    border-radius: 50%;
    margin-top: 10px;
    color: white;
    font-size: 1.0rem;
    font-weight: bold;
    border: 2px solid #057FDB;
    color:  #057FDB;
    margin-bottom: 10px;
    z-index: 2;
    background-color: white;
    margin: auto;
}
.step-no{
    padding-top: 5px;
    display: block;
    width: 31px;
    height: 25px;
    border-radius: 50%;
    margin-top: 10px;
    color: #aaaaaa;
    font-size: 1.0rem;
    font-weight: bold;
    margin-bottom: 10px;
    background-color: white;
    border: 2px solid #aaaaaa;
    margin: auto;
    z-index: 10;
}
.step-no-finished{
    display: block;
    padding-top: 5px;
    width: 30px;
    height: 25px;
    border-radius: 50%;
    margin-top: 10px;
    color: white;
    font-size: 1.0rem;
    margin-bottom: 50px;
    font-weight: bold;
    border: 1px solid #aaaaaa;
    background-color: #aaaaaa;
    color:  white;
    margin: auto;
    z-index: 3;
}
.step-label{
    display: block;
font-size: 1.0rem;
font-family: 微软雅黑;
margin: 5px 0 15px 0;

color: #aaaaaa;
}

.step-label-active {
    display: block;
    font-size: 1.0rem;
font-family: 微软雅黑;
    color: #057FDB;
   margin-top: 5px;
   z-index: 2;
}



</style>